const get = state => state.bptPreferenceAnalysis;
export const getBptPreferenceAnalysisValueForMoneySelector = state => get(state).valueForMoneyData;
